<template>
  <div>
    <div class="row align-items-center mb-3">
      <div class="col-10 custom-pl-15">
        <div class="pr-2">
          <div class="input-group search_tasks_txtbox">

            <autocomplete
              ref="autocomplete1"
              :place-holder-text="placeHolderInputText"
              :result-items="autoCompleteTasksResult"
              :on-key-up="onKeyUpAutoCompleteTasks"
              :on-selected="onSelectedAutoCompleteTasks"
              :auto-complete-progress="autoCompleteTasksProgress"
              :keywordSearch="tasks"
              :classValue="'col-md-12 padding-lr-5 input-height-30 margin-bottom-5'"
              :styleValue="'width: 100%;'"
              >
           </autocomplete>


          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="text-right ">
          <a @click="addOtherTaskModal()" class="help-txt font-weight-bold branding_text_color">Other Skills</a>
        </div>
      </div>
    </div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
      {{ success_message }}
    </b-alert>

    <div class="row mb-3 align-items-end border-bottom mx-1 pb-2">
      <div class="col-6 pl-0">
        <div class="text-uppercase h4 mb-0">Progress</div>
      </div>
      <div class="col-6 pr-0 text-right">
        <div class="text-muted small">Started {{ pathwayStartDate }}</div>
      </div>
    </div>
    <div v-if="loading == true" class="row border-class mb-3 pb-2 align-items-center mx-5 " v-for="option in 3" style="border-bottom: 1px solid #CCC;">
      <div class="col-7">
        <div class="col-12">
          <PuSkeleton :count="1"></PuSkeleton>
        </div>
        <div class="col-10">
          <PuSkeleton :count="1"></PuSkeleton>
        </div>
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <div class="col-12">
          <PuSkeleton :count="1"></PuSkeleton>
        </div>
      </div>

    </div>

    <div class="mentee-progress-list">
    <div class="border-class mb-3 align-items-center mx-3 pr-3 pb-2" v-for="(objective, index) in progress">
    <div class="row">
      <div v-if="objective.objectiveType == 'Other Tasks'" class="col-1" style="margin-top: -8px;">
        <div class="text-uppercase h3 mb-0 text-success">
          <img src="@/assets/manager/Other_skill_set_icon.png" />
        </div>
      </div>
      <div v-else-if="objective.objectiveType == 'Certificate'" class="col-1" style="margin-top: 0px;">
        <div class="text-uppercase h3 mb-0 text-success">
          <img :src="objective.image" width="35px" />
        </div>
      </div>
      <div v-else-if="objective.objectiveType == 'External Course'" class="col-1" style="margin-top: 0px;">
        <div class="text-uppercase h3 mb-0 text-success">
          <img :src="objective.image" width="35px" />
        </div>
      </div>
      <div v-else-if="objective.CompletionPercentage == 100" class="col-1">
        <div class="text-uppercase h3 mb-0 text-success">
          <img src="@/assets/manager/objective_completed.png" />
        </div>
      </div>
      <div v-else-if="objective.CompletionPercentage == 0" class="col-1">
        <div class="text-uppercase h3 mb-0 text-success">
          <img src="@/assets/manager/objective_not_completed.png" />
        </div>
      </div>
      <div v-else class="col-1">
        <div class="progress-circle" :style="'--percent: ' + objective.CompletionPercentage + '%;'">
          <i class="fa fa-check"></i>
        </div>
      </div>

      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'Assessment' || objective.objectiveType == 'Course' || objective.objectiveType == 'Form')">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p v-if="objective.CompletionPercentage == 100" class="small text-muted mb-0">{{ objective.objectiveType }} Completed {{ objective.CompletionDate }}</p>
        <p v-if="objective.CompletionPercentage != 100 && objective.objectiveType == 'Course'" class="small text-muted mb-0">Course - {{ objective.courseCompleteCount }}/{{ objective.totalCourseCount }} Modules Completed</p>
        <p v-if="objective.CompletionPercentage != 100 && objective.objectiveType == 'Assessment'" class="small text-muted mb-0">Assessment</p>
      </div>
      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'Task List')">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p class="small text-muted mb-0">Skill Set - {{ objective.CompletionPercentage }}% Complete</p>
      </div>
      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'Certificate')">
        <div class="row">
        <div class="col-9">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p class="small text-muted mb-0" v-if="objective.expires">Certification - {{ objective.expires }}</p>
        </div>
        <div class="col-3 text-align-right p-0" v-if="((objective.CompletionPercentage != 100) && (objective.regLink != ''))">
          <a class="progress_item_link branding_text_color font-weight-bold" @click="registerFunc(objective.regLink)">Register 
        </a>
        </div>
        </div>
      </div>
      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'External Course')">
        <div class="row">
        <div class="col-9">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p class="small text-muted mb-0" v-if="objective.expires">External Course {{ objective.expires }}</p>
        </div>
        <div class="col-3 text-align-right p-0" v-if="((objective.CompletionPercentage != 100) && (objective.regLink != ''))">
          <a class="progress_item_link branding_text_color font-weight-bold" @click="registerFunc(objective.regLink)">Register 
        </a>
        </div>
        </div>
      </div>
      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'Other Tasks')">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p class="small text-muted mb-0"></p>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="(objective.objectiveType == 'Other Tasks')" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="onOtherTasksAddRepClick(objective.objectiveId, objective.taskListId)">Add Rep 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Assessment') && (objective.CompletionPercentage != 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="goToAssessmentLanding(objective.objectiveId, objective.userAssessmentAttemptId)">{{ objective.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-else-if="((objective.objectiveType == 'Assessment' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="viewReport(objective.userAssessmentAttemptId)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Form') && (objective.CompletionPercentage != 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="openMenteeFillFormModal(objective.objectiveId)">{{ objective.buttonName }} <img  v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Form' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="goToViewForm(objective.objectiveId)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
        <br />
        <a class="progress_item_link branding_text_color font-weight-bold" @click="openMenteeEditFormModal(objective.objectiveId, objective.userId)" style="padding-right: 30px;">Edit Form 
          
        </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Course') && (objective.CompletionPercentage != 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="goToCourseLanding(objective.lmsCourseId, objective.lmsUserId)">{{ objective.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Course' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="viewCourseReport(objective.cert)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>

      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Certificate') && (objective.CompletionPercentage != 100) && (objective.buttonName != ''))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="uploadCertificationModalOpen(objective.objectiveId, objective.id)">{{ objective.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Certificate' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="downloadFunc(objective.fileName)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>

      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'External Course') && (objective.CompletionPercentage != 100) && (objective.buttonName != ''))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="openCourseCertificationModal(objective.objectiveId, objective.id)">{{ objective.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'External Course' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="downloadCourseFunc(objective.fileName)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>


      <div class="col-4 col-xl-4 pr-0 text-right" v-if="objective.objectiveType == 'Task List'" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click.prevent="openTaskListModal(objective.objectiveId)">Skills 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
    </div>
    </div>
    </div>

    <MenteeTasklists 
      :isModalVisible="isTaskListModalVisible"
      @close="closeTaskListModal"
      @closeTaskListModal="closeTaskListModal"
      @closeAddRep="closeAddRep"
      ref="TaskListModal">
    </MenteeTasklists>

    <MenteeAddRep
      :isModalVisible="isMenteeAddRepModalVisible"
      @closeMenteeAddRepModal="closeMenteeAddRepModal"
      @closeMenteeEditRepModal="closeMenteeEditRepModal"
      ref="MenteeAddRepModal">
    </MenteeAddRep>

    <MenteeTasklistsOtherTask 
      :isModalVisible="isOtherTaskModalVisible"
      :type="2"
      :menteeId="menteeId"
      @closeTaskListOtherTasksModal="closeTaskListOtherTasksModal"
      ref="TaskListOtherTaskModal">
    </MenteeTasklistsOtherTask>

    <MenteeAssessmentLandingPage 
      :isModalVisible="isAssessmentLandingVisible"
      @closeAssessmentLandingModal="closeAssessmentLandingModal"
      @openAssessmentQuestionModal="openAssessmentQuestionModal"
      ref="MenteeAssessmentLandingModal">
    </MenteeAssessmentLandingPage>

    <MenteeAssessmentQuestionPage 
      :isModalVisible="isAssessmentQuestionVisible"
      @closeAssessmentQuestionModal="closeAssessmentQuestionModal"
      ref="MenteeAssessmentQuestionModal">
    </MenteeAssessmentQuestionPage>

    <MenteeFillForm 
      :isModalVisible="isMenteeFillFormVisible"
      @closeMenteeFillFormModal="closeMenteeFillFormModal"
      ref="MenteeFillFormModal">
    </MenteeFillForm>

    <MenteeEditForm 
      :isModalVisible="isMenteeEditFormVisible"
      @closeMenteeEditFormModal="closeMenteeEditFormModal"
      ref="MenteeEditFormModal">
    </MenteeEditForm>

    <div v-if="isMenteeUploadComponentVisible">
    <MenteeUploadCertificate 
      :isModalVisible="isMenteeUploadComponentVisible"
      :type="2"
      @close="uploadCertificationModalClose"
      @closeMenteeUploadModal="uploadCertificationModalClose"
      ref="MenteeUploadModal">
    </MenteeUploadCertificate>
    </div>

    <div v-if="isCourseCertificationModalVisible">
    <MenteeUploadCourseCertifications 
      :isModalVisible="isCourseCertificationModalVisible"
      :type="type"
      @close="closeCourseCertificationModal"
      @closeTaskListModal="closeCourseCertificationModal"
      ref="CourseCertificationModal">
    </MenteeUploadCourseCertifications>
    </div>


  </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import RightPanelModal from '@/components/manager/right_panel_modal.vue';
import MenteeTasklists from '@/components/mentee/mentee_tasklists_new.vue';
import autocomplete from '@/components/admin/autocomplete.vue';
import MenteeAddRep from '@/components/mentee/mentee_add_rep.vue';
import MenteeTasklistsOtherTask from '@/components/manager/mentee_tasklist_add_othertask_from_progress_modal.vue';
import MenteeAssessmentLandingPage from '@/components/mentee/mentee_assessment_landing_new.vue';
import MenteeAssessmentQuestionPage from '@/components/mentee/mentee_assessment_question_new.vue';
import MenteeFillForm from '@/components/mentee/mentee_fill_form_new.vue';
import MenteeEditForm from '@/components/mentee/mentee_update_form_new.vue';
import MenteeUploadCertificate from '@/components/manager/mentee_upload_certificate.vue';
import MenteeUploadCourseCertifications from '@/components/manager/mentee_upload_course_certificate.vue';


export default {
  props: ['isModalVisible', 'stepId', 'pathwayId'],
  data() {
    return {
      progress: [],
      taskListId: '',
      nextStepId: '',
      nextStepTitle: '',
      currentStepId: '',
      stepIsCompleted: false,
      pathwayStartDate: '',
      isTaskListModalVisible: false,
      placeHolderInputText: 'Search tasks',
      autoCompleteTasksResult: [],
      autoCompleteTasksProgress: false,
      tasks: '',
      tasksId: '',
      subTaskId: '',
      isMenteeAddRepModalVisible: false,
      isOtherTaskModalVisible: false,
      menteeId: '',
      isAssessmentLandingVisible: false,
      isAssessmentQuestionVisible: false,
      isMenteeFillFormVisible: false,
      isMenteeEditFormVisible: false,
      loading: false,
      success_message: '',
      dismissCountDown: 0,
      isMenteeUploadComponentVisible: false,
      isCourseCertificationModalVisible: false,

    }
  },
  components: {
    RightPanelModal,
    MenteeTasklists,
    autocomplete,
    MenteeAddRep,
    MenteeTasklistsOtherTask,
    MenteeAssessmentLandingPage,
    MenteeAssessmentQuestionPage,
    MenteeFillForm,
    MenteeEditForm,
    MenteeUploadCertificate,
    MenteeUploadCourseCertifications,
  },
  methods: {
    closeAddRep() {
      this.$parent.getAccountStatistics();
    },
    downloadCourseFunc: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/course_certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
    openCourseCertificationModal(courseId, objectiveId) {
      this.isCourseCertificationModalVisible = true;
      setTimeout(() => { 
      this.$refs.CourseCertificationModal.getMenteeCertificatesData(this.menteeId, courseId, this.currentStepId, objectiveId);
      }, 500);
    },
    closeCourseCertificationModal() {
      this.reloadStep(this.currentStepId);
      this.isCourseCertificationModalVisible = false;
    },
    registerFunc: function(url) {
      window.open(url, '_blank');
      return false;    
    },
    downloadFunc: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
    uploadCertificationModalOpen(certId, stepObjectiveId) {
      this.isMenteeUploadComponentVisible = true;
      setTimeout(() => { 
      this.$refs.MenteeUploadModal.getMenteeCertificatesData(this.menteeId, certId, this.currentStepId, stepObjectiveId);
      }, 500);
    },
    uploadCertificationModalClose() {
      this.getMenteeProgressData(this.currentStepId);  
      this.isMenteeUploadComponentVisible = false;
    },
    openMenteeFillFormModal(formId) {
      this.$refs.MenteeFillFormModal.getFormData(formId);
      this.isMenteeFillFormVisible = true;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    closeMenteeFillFormModal(flag) {
      if(flag == 1) {
        this.success_message = 'Form successfully completed!';
        this.dismissCountDown = 5;
        this.reloadStep(this.currentStepId);
      }
      this.isMenteeFillFormVisible = false;
    },
    openMenteeEditFormModal(formId, userId) {
      this.$refs.MenteeEditFormModal.getFormData(formId, userId);
      this.isMenteeEditFormVisible = true;
    },
    closeMenteeEditFormModal(flag) {
      if(flag == 1) {
        this.success_message = 'Form successfully completed!';
        this.dismissCountDown = 5;
      }
      this.isMenteeEditFormVisible = false;
    },
    goToCourseLanding(courseId, lmsUserId) {
      var dashboardPath = this.$route.fullPath;
      dashboardPath = dashboardPath.replace(/^\/+/,"");
     
      router.push('/take-course/'+ lmsUserId + '/' + dashboardPath + '?c=' + courseId);
    },
    goToAssessmentLanding(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = true;
    },
    closeAssessmentLandingModal() {
      this.isAssessmentLandingVisible = false;
    },
    openAssessmentQuestionModal(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentQuestionModal.getScaleLists(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = false;
      this.isAssessmentQuestionVisible = true;
    },
    closeAssessmentQuestionModal () {
      this.isAssessmentQuestionVisible = false;
    },
    closeTaskListOtherTasksModal() {
      this.reloadStep(this.currentStepId);
      this.$parent.getAccountStatistics();
      this.isOtherTaskModalVisible = false;
    },
    addOtherTaskModal() {
      this.$refs.TaskListOtherTaskModal.getTaskLists(this.menteeId);
      this.isOtherTaskModalVisible = true;
    },
    openMenteeAddRepModal() {
      this.$refs.MenteeAddRepModal.getRepData(this.taskListId, this.subTaskId, this.tasksId, this.menteeId, 'no', '', '');
      this.isMenteeAddRepModalVisible = true;
    },  
    closeMenteeAddRepModal(subtaskIndex, type) {
      this.$refs.autocomplete1.setValue('');
      this.$parent.getAccountStatistics();
      this.isMenteeAddRepModalVisible = false;
    },
    closeMenteeEditRepModal() {
      this.$refs.autocomplete1.setValue('');
      this.isMenteeAddRepModalVisible = false;
    },
    onKeyUpAutoCompleteTasks(keywordEntered){
      this.autoCompleteTasksResult = [];
      this.tasks = keywordEntered;
      this.autoCompleteTasksProgress = false;
      
      setTimeout(() => {
      if(keywordEntered.length == 0) {
        this.autoCompleteTasksResult = [];
      }
      }, 2000); 
      if(keywordEntered.length > 0){
        this.autoCompleteTasksProgress = true;
        const params = { tasks: keywordEntered }
        params.mentee_id = this.menteeId;
        axios.get("/desktop/v2/tasks_autocomplete", {
           params: params
        })
        .then(response => {
          var newData = [];
          response.data.forEach(function(item, index){
            if(item.id){
              newData.push({
                'itemId' : item.id,
                'itemText' : item.description,
                'itemList': item,
              });
            }
          });
          this.autoCompleteTasksResult = newData;
          this.autoCompleteTasksProgress = false;
        })
        .catch(e => {
          this.autoCompleteTasksProgress = false;
          this.autoCompleteTasksResult = [];
        })
      }else{
        this.autoCompleteTasksProgress = false;
        this.autoCompleteTasksResult = [];
      }
    },
    onOtherTasksAddRepClick(taskId, taskListId) {
      this.tasksId = taskId;
      this.taskListId = taskListId;
      const params = { task_id: this.tasksId }
      params.mentee_id = this.menteeId;
      params.tasklist_id = taskListId;
      axios.get("/desktop/v2/tasks_autocomplete/get_tasks_details", {
         params: params
      })
      .then(response => {
        this.subTaskId = response.data.subtaskId;
        this.taskListName = response.data.taskListName;
        this.menteeName = response.data.menteeName;
        this.openMenteeAddRepModal();
      })
      .catch(e => {
      })

    },
    onSelectedAutoCompleteTasks(item){
      this.autoCompleteTasksProgress = false;
      this.autoCompleteTasksResult = [];
      this.tasks = item.description.toString();
      this.tasksId = item.id;
      this.taskListId = item.tasklistId;
      this.$refs.autocomplete1.setValue(this.tasks);

      const params = { task_id: this.tasksId }
      params.tasklist_id = this.taskListId;
      axios.get("/desktop/v2/tasks_autocomplete/get_tasks_details", {
         params: params
      })
      .then(response => {
        this.subTaskId = response.data.subtaskId;
        this.taskListName = response.data.taskListName;
        this.menteeName = response.data.menteeName;
        this.openMenteeAddRepModal();
      })
      .catch(e => {
      })



    },


    openTaskListModal(taskListId) {
      this.isTaskListModalVisible = true;
      this.$refs.TaskListModal.getMenteeTasklistsData(taskListId);
    },
    closeTaskListModal() {
      this.isTaskListModalVisible = false;
    },
    viewCourseReport: function(url) {
        window.open(url, '_blank');
    },
    goToViewForm(formId) {
      var formViewUrl = '/desktop/forms-manager/view-form/'+formId+'/' + this.$store.state.user_accountid;
      
      axios.get(formViewUrl, {
      })
      .then(response =>  {        
        window.open(process.env.API_ENDPOINT + '/web/forms/' +response.data.filepath, '_blank');                        
      })
      .catch(function(err) {
        console.log("Come here"+ err);
      });
    },
    viewReport: function(id) {
       let routeData = this.$router.resolve({name: 'assessmentreportnew', params: {assessmentAttemptId: id}});
        window.open(routeData.href, '_blank');
    },
    openTasklistModal(event, taskListId) {
      this.taskListId = taskListId;
      event.preventDefault();
      event.stopPropagation();
      this.$refs.rightPanelModal.show();
    },
    reloadStep(stepId) {
      this.getMenteeProgressData(stepId);  
    },
    getMenteeProgressData(stepId) {
      this.loading = true;
      this.currentStepId = stepId;
      axios.get('/desktop/v2/mentee/get-mentee-progress', {
        params: {
          account_id: this.$store.state.user_accountid,
          step_id: stepId,
          pathway_id: this.pathwayId,
        }
      })
      .then(response =>  {      
        this.loading = false;    
        this.progress = response.data.progress;
        this.menteeId = response.data.menteeId;   
        this.pathwayStartDate = response.data.pathwayStartedDate;
      })
      .catch(function() { });
    },
  },
  created() {
    this.getMenteeProgressData(this.stepId);
  },
}
</script>


<style scoped>
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.progress-circle {
  position: relative;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: conic-gradient(#00acee var(--percent, 0%), lightgrey 0%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-circle .fa-check {
  font-size: 0.8rem;
}
.progress-circle::before {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  border-radius: 50%;
  background: white;
  z-index: 1;
}
.progress-circle .fa-check {
  z-index: 2;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
@media (max-width: 1199.98px) {
  .progress_item_link {
    font-size: 13px;
    cursor: pointer;
  }
}
.progress_item_link {
  cursor: pointer;
}
.objective-view-icon {
  width: 15px;
  margin-left: 2px !important;
}
</style>
<style>
.search_tasks_txtbox .autocomplete {
  width: 100%;
}
.search_tasks_txtbox .autocomplete input {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 5px;
  height: 28px;
  padding-bottom: 0px;
  padding-top: 0px;
  border: 1px solid lightgray;
}
a {
  cursor: pointer;
}
.mentee-progress-list .border-class:not(:last-child) {
  border-bottom: 1px solid #CCC;
}
</style>



// WEBPACK FOOTER //
// src/components/mentee/mentee_progress.vue